// =====================================================================
// Chamados — SOLICITAÇÃO DE IMAGEM: o espelho de tela do módulo do servidor.
// =====================================================================
// ⚠️⚠️ ESTE ARQUIVO É ESPELHO de `server/chamados/chamados-imagem.js`, e existe
//    porque o front (Create React App) NÃO importa de `server/`. Mudou um, muda
//    o outro — há teste travando (`server/tests/espelhos-back-front.test.js`,
//    par 4). Divergir não dá erro em lugar nenhum: o sintoma é a tela oferecer
//    32 canais num quiosque de 4, e o servidor recusar o envio com uma mensagem
//    que a pessoa não tem como entender olhando o formulário.
//
// ⚠️ AUTOCONTIDO DE PROPÓSITO — nada de `import` aqui. É o que permite ao teste
//    do backend carregá-lo dentro do Jest (que é CommonJS).
//
// ⚠️ O que NÃO vem para cá: a validação inteira (`validarPedidoImagem`). A tela
//    valida o que evita ida-e-volta; a REGRA é do servidor. Duplicar a validação
//    completa seria duas verdades sobre o mesmo assunto.
// =====================================================================

/** O nome do tipo, EXATO como está na lista do servidor (com acento). */
export const TIPO_IMAGEM = 'Solicitação de Imagem';

/**
 * Para quem a imagem vai, e como isso se lê na tela.
 * ⚠️ As CHAVES são o que o banco grava (o `ENUM`); o texto é só rótulo.
 */
export const DESTINOS_IMAGEM = [
  { valor: 'Loja', rotulo: 'Devolver para a loja' },
  { valor: 'RH', rotulo: 'Encaminhar ao RH' },
];

/** Os tetos de canal por natureza do ponto (Julia, 14/09/2026). */
export const CANAIS_MAX = { loja: 32, quiosque: 4 };

/** O chamado é um pedido de imagem? Casamento exato, como no servidor. */
export function ehSolicitacaoImagem(tipo) {
  return String(tipo || '') === TIPO_IMAGEM;
}

/**
 * Quantos canais o ponto tem: quiosque escolhido → 4; senão → 32.
 *
 * ⚠️ É DERIVADO do seletor de quiosque que a abertura já tem — a tela nunca
 *    pergunta "é quiosque?" de novo. Perguntar abriria espaço para o formulário
 *    e o chamado se contradizerem.
 */
export function tetoDeCanais(quiosque) {
  return String(quiosque || '').trim() ? CANAIS_MAX.quiosque : CANAIS_MAX.loja;
}

/** O rótulo de leitura dos canais: '3, 7 e 12'. */
export function rotuloCanais(canais) {
  const lista = String(canais || '').split(',').map((c) => c.trim()).filter(Boolean);
  if (!lista.length) return '—';
  if (lista.length === 1) return lista[0];
  return `${lista.slice(0, -1).join(', ')} e ${lista[lista.length - 1]}`;
}
